export default __webpack_public_path__ + "static/media/bootstrap.361d61e8.gif";